/* @flow */

/**
 * @module _adrenderbase
 * @exports _adrenderbase
 * @description Base interface for all ad server renderer
 * @abstract
 */

export default class _adrenderbase {
  _doc: Document;

  _win: WindowProxy;

  _name: string;

  _as: string;

  /**
   * @class
   * @param {string} name Renderer class name
   * @param {string} as Ad server name
   */
  constructor(name: string = '', as: string = '') {
    this._doc = document;
    this._win = window;
    this._name = name;
    this._as = as;
  }

  /**
   * @description get ad server name this object is associated with
   * @returns {string} - ad server name
   */
  getAS(): string {
    return this._as;
  }

  /**
   * @description render the given ad
   * @param {module:adloader.adInfo} adInfoObj adInfo object
   * @param {string} containerID ID to render into
   * @returns {boolean} Rendering success/failure
   */
  // eslint-disable-next-line no-unused-vars
  renderAd(adInfoObj: adInfo, containerID: string): boolean {
    return true;
  }
}
